import { HiReceiptTax } from "react-icons/hi";
import { MdRequestQuote } from "react-icons/md";
import { ADD_BILL } from "../../routes";

export const ADMIN_ROLE = "admin";
export const HO_ROLE = "ho";

export const FORM_MODES = {
    ADD: "add",
    VIEW: "view",
};

export const VALIDATION_MESSAGES = {
    SITE_REQUIRED: "Site is required",
    DATE_REQUIRED: "Date is required",
    AMOUNT_REQUIRED: "Amount is required",
    TYPE_REQUIRED: "Type is required",
    CATEGORY_REQUIRED: "Category is required",
    IMAGE_VALIDATION: "Please Upload a valid image ",
    NO_RESPONSE_DATA:"No Response Data"
};

export const BILL_LABELS = {
    site: "Site",
    date: "Date",
    user: "User",
    type: "Type",
    amount: "Amount",
    category: "Category",
    status: "Status",
    actions: "Actions",
};

export const BILL_COLUMNS = {
    ADMIN: ["site", "type", "category", "date", "amount", "user", "status", "actions"],
    USER: ["site", "type", "category", "date", "amount", "status", "actions"],
};

export const FORM_TITLES = {
    ADD: "Add Bill",
    VIEW: "View Bill",
};

export const BUTTON_TEXT = {
    BACK: "Back",
    CANCEL: "Cancel",
    SUBMIT: "Add Bill",
    SUBMITTING: "Submitting...",
    APPROVE: "Approve",
    REJECT: "Reject",
    GO_HOME: "Go to Home",
    ADD_BILL: "Add Bill",
    DELETE_BILL: "Delete Bill"
};

export const ICON_TITLES = {
    VIEW: "View",
    APPROVE: "Approve",
    REJECT: "Reject",
    DELETE: "Delete"
};

export const FIELD_LABELS = {
    SITE: "Site",
    DATE: "Date",
    AMOUNT: "Amount",
    TYPE: "Type",
    CATEGORY: "Category",
    PHOTO: "Photo",
    STATUS: "Status",
    UPDATED_ON: "Updated On",
    USER: "User",
};

export const TOAST_MESSAGES = {
    BILL_ADD_SUCCESS: "Bill added successfully",
    BILL_ADD_ERROR: "Something went wrong",
    BILL_LOAD_ERROR: "Failed to load bill",
    SITES_LOAD_ERROR: "Failed to load sites",
    CATEGORIES_LOAD_ERROR: "Failed to load categories",
    STATUS_UPDATE_SUCCESS: (status) => `Bill ${status} successfully`,
    BILL_STATUS_ERROR: "Failed to update bill status",
    BILLS_FETCH_ERROR: "Failed to load bills",
    FAILED_TO_FETCH: "Failed to fetch",
    BILL_DELETE: "Bill Deleted Successfully",
    BILL_DELETE_ERROR: "Failed to delete bill",
    DELETE_ALERT: "Are you sure you want to delete this bill?",
    USER_FETCH_ERROR : "Failed to fetch users"
};

export const MISC = {
    NO_IMAGE: "No image uploaded",
    NOT_AVAILABLE: "N/A",
    NO_BILLS_FOUND: "No Bills Found"
};

export const PAGE_TITLE = "Bills";

export const STATUS = {
    APPROVED: "approved",
    REJECTED: "rejected",
    PENDING_L1_APPROVAL: "PENDING_L1_APPROVAL",
    PENDING_L2_APPROVAL: "PENDING_L2_APPROVAL",
};

export const DEFAULT_STATUS_OPTIONS = [
    { label: "All", value: "" },
    { label: "Approved", value: "APPROVED" },
    { label: "Rejected", value: "REJECTED" },
    { label: "pending  L1 Approval", value: "PENDING_L1_APPROVAL" },
    { label: "pending  L2 Approval", value: "PENDING_L2_APPROVAL" },
];


export const EXCEL_FILE_COLUMNS = [
    { label: "Site", value: "site_name" },
    { label: "Amount", value: "amount" },
    { label: "Category", value: "category_name" },
    { label: "Date", value: (item) => new Date(item.date).toLocaleDateString() },
    { label: "User", value: "user_name" },
    { label: "Status", value: "status" },
    { label: "Photo", value: "bill_file" },
]
export const TYPES_OPTIONS = [
    { label: "Purchase", value: "PURCHASE" },
    { label: "Reimbursement", value: "REIMBURSEMENT" }
]

const commonCss = "w-10 h-10 md:w-12 md:h-12";
const subMenuCss = "items-center";

export const BILL_POPUP_FIELDS = [
    {
        title: "Bill",
        label: "Add Purchase",
        icon: (
            <HiReceiptTax
                className={`${commonCss} text-yellow-600 ${subMenuCss}`}
            />

        ),
        link: ADD_BILL.replace(":billType", "purchase"),
    },
    {
        title: "Bill",
        label: "Add Reimbursement",
        icon: (
            <MdRequestQuote
                className={`${commonCss} text-yellow-600 ${subMenuCss}`}
            />

        ),
        link: ADD_BILL.replace(":billType", "reimbursement"),
    }
]
